module.exports = __webpack_public_path__ + "static/IoT-0089257ed557c827284e2dd44fcb81c5.png";